import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/service/user.service';
import { RoleService } from 'src/app/service/role.service';

@Component({
  selector: 'app-role-update',
  templateUrl: './role-update.component.html',
  styleUrls: ['./role-update.component.scss']
})
export class RoleUpdateComponent implements OnInit {
  roleID: any;
  showLoader: boolean = false;
  updating: boolean = false;
  role: any;
  currentActiveValue: any;
  rolename: any;
  permissions: any;
  roleSelectedPermissions: any;
  rolePermissions: any;
  oldPermissions: any;
  newPermissions: any;
  dropdownSettings: any = {};
  ShowFilter = true;
  limitSelection = false;
  permissionsData: any;

  editRole = new FormGroup({
    roleName: new FormControl('', [
      Validators.required,
    ]),
    permissions: new FormControl('', [
      Validators.required,
    ]),
    active: new FormControl('', [
      Validators.required
    ])
  });

  constructor(public globals: Globals, private toastrService: ToastrService, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService
    , private userService: UserService
    , private roleService: RoleService) { }

  ngOnInit(): void {
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.roleID = params['roleId'] || "";

        if (this.roleID != "") {
          this.showLoader = true;
          this.getRoleById();
          this.dropdownSettings = {
            singleSelection: false,
            idField: 'item_id',
            textField: 'item_text',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 24,
            allowSearchFilter: this.ShowFilter
          };
        } else {
          this.toastrService.warning(this.translate.instant('CAN_NOT_GET_ROLE'));
          this.router.navigate(['/roles']);
        }
      });
  }

  getRoleById() {
    this.showLoader = true;
    this.roleService.getRoleById(this.roleID)
      .subscribe(
        data => {
          this.role = data;
          this.editRole.controls.roleName.setValue(data.roleName);
          this.editRole.controls.active.setValue(data.active);
          this.currentActiveValue = data.active;
          this.getAllPermission();
        },
        error => {
          this.toastrService.warning(this.translate.instant("CAN_NOT_GET_USER"));
          this.router.navigate(['/roles']);
          this.showLoader = false;
        }
      );
  }

  getAllPermission() {
    this.roleService.getAllPermissions()
      .subscribe(
        data => {
          console.log("All permissions: ");
          console.log(data);
          this.permissionsData = data;
          this.permissions = this.permissionsData.map((permission: any) => {
            return {
              item_id: permission.id, item_text: permission.moduleNameEn + "(" + permission.functionOptionCombined + ")"
            }
          });
          console.log("all permissions after mapping :");
          console.log(this.permissions);
          this.getRolePermissions();
        },
        error => {
          this.toastrService.warning(this.translate.instant('CAN_NOT_GET_ALL_PERMISSIONS'));
          this.router.navigate(['/roles']);
          this.showLoader = false;
        }
      );
  }

  getRolePermissions() {
    let rolePermissions;
    this.roleService.getRolePermissions(this.roleID)
      .subscribe(
        data => {
          console.log("role permission data :");
          console.log(data);
          rolePermissions = data;
          this.roleSelectedPermissions = rolePermissions.map((permission: any) => {
            return {
              item_id: permission.optionid, item_text: permission.moduleNameEn + "(" + permission.functionOptionCombined + ")"
            }
          });
          console.log("role permission after mapping :");
          console.log(this.roleSelectedPermissions);
          this.showLoader = false;
        },
        error => {
          this.toastrService.warning(this.translate.instant('CAN_NOT_GET_ROLE_PERMISSIONS'));
          this.router.navigate(['/roles']);
          this.showLoader = false;
        }
      );
  }


  // let parentRoles = this.editRole.controls.parent?.value.map((item: any) => {
  //   return { id: item.item_id, name: item.item_text }
  // });

  onItemSelect(item: any) {
    // console.log('onItemSelect', item);
  }
  onSelectAll(items: any) {
    // console.log('onSelectAll', items);
  }

  toogleShowFilter() {
    this.ShowFilter = !this.ShowFilter;
    this.dropdownSettings = Object.assign({}, this.dropdownSettings, { allowSearchFilter: this.ShowFilter });
  }

  handleLimitSelection() {
    if (this.limitSelection) {
      this.dropdownSettings = Object.assign({}, this.dropdownSettings, { limitSelection: 2 });
    } else {
      this.dropdownSettings = Object.assign({}, this.dropdownSettings, { limitSelection: null });
    }
  }

  editRoleChange() {

  }

  editRoleSubmit() {

    if (this.editRole.valid) {
      let roleName = this.editRole.controls.roleName.value;
      let active = this.editRole.controls.active.value;
      let permissionToAdd = "";
      let permissionToDelete = "";

      // Update user info
      this.updateRole(roleName, active);

    }
    else {
      this.editRole.markAllAsTouched();
      this.editRole.markAsDirty();
    }
  }

  updateRole(roleName: string, active: string) {

    this.updating = true;
    let updateBy = this.globals.currentUserInfo.username;
    this.roleService.updateRole(this.roleID, roleName, updateBy, active).subscribe(
      data => {
        // console.log("New permission to added");
        this.newPermissions = this.editRole.controls.permissions?.value.map((permission: any) => {
          let selectedPermission = this.permissionsData.filter((purePermission: any) => purePermission.id == permission.item_id)[0];
          if (typeof selectedPermission != undefined) {
            return selectedPermission;
          }
        });
        // console.log(this.newPermissions);
        // this.updating = false;
        // this.deleteRolePermissions();
        this.deleteRolePermissionsByRoleId();
        this.toastrService.success(this.translate.instant("UPDATED_SUCCESSFULLY"));
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_UPDATE_ROLE"));
        this.updating = false;
      }
    );
  }


  addRolePermissions() {
    let count = this.newPermissions.length;
    let counter = 0;
    let active = "TRUE";
    this.newPermissions.forEach((permission: any) => {
      this.roleService.addUserRoleOption(this.roleID, permission.productid, permission.moduleid, permission.menuid, permission.functionid, permission.optionid, active).subscribe(
        data => {
          counter++
          if (counter == count) {
            this.toastrService.success(this.translate.instant("ROLE_PERMISSION_UPDATED_SUCCESSFULLY"));
            this.updating = false;
            this.router.navigate(['/roles']);
          }
        },
        error => {
          this.toastrService.error(this.translate.instant("CAN_NOT_UPDATE_ROLE_PERMISSION"));
          this.updating = false;
        }
      );
    });
  }

  deleteRolePermissionsByRoleId() {
    this.roleService.deleteUserRoleOptionByRoleId(this.roleID).subscribe(
      data => {
        this.addRolePermissions();
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_DELETE_ROLE_PERMISSIONS"));
        this.updating = false;
      }
    );
  }

  //   deleteRolePermissions() {
  //   let count = this.oldPermissions.length;
  //   let counter = 0;
  //   this.oldPermissions.forEach((permission: any) => {
  //     this.roleService.deleteUserRoleOption(permission.id).subscribe(
  //       data => {
  //         counter++
  //         if (counter == count) {
  //           this.addRolePermissions();
  //         }

  //       },
  //       error => {
  //         this.toastrService.error(this.translate.instant("CAN_NOT_DELETE_ROLE_PERMISSION"));
  //       }
  //     );
  //   });
  // }


  getRoleInfo() {

  }

}
